import { createBrowserRouter } from 'react-router';
import { APP_CHILDREN } from './routes.tsx';
import { AppLayout } from './components/AppLayout.tsx';
import { LoginPage } from './pages/auth/LoginPage.tsx';
import { MfaVerifyPage, MfaEnrollPage } from './pages/auth/MfaPage.tsx';
import { InvitePage } from './pages/auth/InvitePage.tsx';
import { WorkspacesPage, MagicLinkPage } from './pages/auth/WorkspacesPage.tsx';

import { useEffect } from 'react';
import { Navigate } from 'react-router';

function ToLogin() { return <Navigate to="/login" replace />; }

/** CR-040: 옛 /app/… 링크(발송된 메일·북마크)는 접두어를 떼고 같은 호스트로 보낸다 */
function LegacyAppPrefix() {
  useEffect(() => { const { pathname, search, hash } = window.location; window.location.replace(`${pathname.replace(/^\/app(?=\/|$)/, '') || '/'}${search}${hash}`); }, []);
  return null;
}
/** 앱 라우터 (CR-040: app.isms-p.kr 루트, basename 없음). main.tsx 가 호스트를 보고 만든다 */
export const createAppRouter = () => createBrowserRouter([
  { path: '/app/*', Component: LegacyAppPrefix },
  // 인증 없이 접근 (테넌트는 ?tenant= 또는 저장된 슬러그로 식별)
  { path: '/login', Component: LoginPage },
  { path: '/login/magic', Component: MagicLinkPage }, // CR-067 매직링크 도착
  { path: '/workspaces', Component: WorkspacesPage }, // CR-067 조직 선택·전환
  { path: '/mfa', Component: MfaVerifyPage },
  { path: '/mfa/enroll', Component: MfaEnrollPage },
  { path: '/invite/:token', Component: InvitePage },
  // CR-067: 재설정 링크 폐지 — 메일 링크로 로그인한 뒤 내 계정에서 정한다. 옛 링크는 로그인으로 보낸다
  { path: '/forgot', Component: ToLogin },
  { path: '/reset/:token', Component: ToLogin },
  { path: '/', Component: AppLayout, children: APP_CHILDREN },
  // 수탁사 포털은 /portal 하위 별도 레이아웃 (3단계)
]);
